import React from 'react';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import {
  faCalendarCirclePlus,
  faEnvelopeOpenText,
  faPeopleArrows,
} from '@fortawesome/pro-light-svg-icons';
import styled from 'styled-components';
import { rem } from 'polished';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'gatsby';
import { Text } from '../Text';

const StyledContactList = styled.ul`
  list-style: none;
  padding: 0;

  .contact-list__item {
    margin-bottom: ${rem(`4px`)};
    display: flex;
    align-items: flex-start;
    text-align: left;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .contact-list__icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${rem(`30px`)};
    min-width: ${rem(`30px`)};
  }
  .contact-list__icon {
    color: ${({ theme }) => theme.colors.yellow_1};
    font-size: ${rem(`20px`)};
  }
  .contact-list__content {
    margin-left: ${rem(`6px`)};
    line-height: ${rem(`30px`)};
    ${(props) => props.theme.breakpoints.desktop`
      padding-right: ${rem(`32px`)};
    `}
  }
  .contact-list__link {
    color: ${({ theme }) => theme.colors.pink_1};
    transition: color 300ms ease;
    max-height: ${rem(`30px`)};
    :hover {
      color: ${({ theme }) => theme.colors.pink_2};
    }
  }
`;

interface IContactList {
  className?: string;
  disableSocial?: boolean;
}

export const ContactList = ({
  className,
  disableSocial = false,
}: IContactList) => {
  const onClickHandler = () => {
    // eslint-disable-next-line no-undef
    Calendly.initPopupWidget({
      url: `https://calendly.com/domusnetwork?hide_landing_page_details=1&hide_gdpr_banner=1`,
      parentElement: document.getElementById(`calendly-embed`),
      resize: true,
    });
    return false;
  };

  return (
    <StyledContactList className={`contact-list ${className}`}>
      <li className="contact-list__item">
        <div className="contact-list__icon-container">
          <FontAwesomeIcon className="contact-list__icon" icon={faWhatsapp} />
        </div>
        <Text
          className="contact-list__content"
          type="body1"
          tag="span"
          color="gray_3"
          noRhythem
        >
          Chat on{` `}
          <a
            href="https://wa.me/message/OWWIU4C5SXVXB1"
            target="_blank"
            rel="noreferrer"
            className="contact-list__link"
          >
            WhatsApp
          </a>
        </Text>
      </li>

      <li className="contact-list__item">
        <div className="contact-list__icon-container">
          <FontAwesomeIcon
            className="contact-list__icon"
            icon={faCalendarCirclePlus}
          />
        </div>

        <Text
          className="contact-list__content"
          type="body1"
          tag="span"
          color="gray_3"
          noRhythem
        >
          <button
            type="button"
            onClick={onClickHandler}
            className="contact-list__link"
          >
            Schedule a meeting
          </button>
        </Text>
      </li>

      <li className="contact-list__item">
        <div className="contact-list__icon-container">
          <FontAwesomeIcon
            className="contact-list__icon"
            icon={faEnvelopeOpenText}
          />
        </div>
        <Text
          className="contact-list__content"
          type="body1"
          tag="span"
          color="gray_3"
          noRhythem
        >
          Fill out the{` `}
          <Link to="/contact" className="contact-list__link">
            contact
          </Link>
          {` `}form
        </Text>
      </li>

      {!disableSocial && (
        <li className="contact-list__item">
          <div className="contact-list__icon-container">
            <FontAwesomeIcon
              className="contact-list__icon"
              icon={faPeopleArrows}
            />
          </div>
          <Text
            className="contact-list__content"
            type="body1"
            tag="span"
            color="gray_3"
            noRhythem
          >
            Reach out through our social profiles below
          </Text>
        </li>
      )}
    </StyledContactList>
  );
};
